import '../styles.scss'
import '../responsive.scss'

import { PageProps } from 'gatsby'
import React, { useEffect } from 'react'

import Footer from '@/components/footer/footer'
import PageHeader from '@/components/page-header/page-header'
import ShareButtons from '@/components/share/share-buttons'
import { useAnchorScrollFix } from '@/hooks/use-anchor-scroll-fix'
import { setStoredUTMParams } from '@/utils/analytics'
type Props = {
  shareButtonsScrollTop?: number
  location: PageProps['location']
  children: React.ReactNode
  showNavigation?: boolean
}
const Layout: React.FC<Props> = ({
  shareButtonsScrollTop = 40,
  location,
  children,
  showNavigation = true
}) => {
  const isRootPath = location?.pathname === '/'

  // Fix anchor scroll positioning for direct access vs navigation
  useAnchorScrollFix()

  useEffect(() => {
    setStoredUTMParams(location)
  }, [location])
  // TODO: is necessary data-is-root-path={isRootPath}?
  return (
    <div className="global-wrapper" data-is-root-path={isRootPath}>
      <PageHeader location={location} showNavigation={showNavigation} />
      <main className="main-content">{children}</main>
      <ShareButtons location={location} visibleaAt={shareButtonsScrollTop} />
      {/* <ModalSubscription /> */}
      <Footer showNavigation={showNavigation} />
    </div>
  )
}

export default Layout
